export default {
    methods: {
        showToast(title, content, variant, { append = true, autoHideDelay = 5000 } = {}) {
            this.$bvToast.toast(content, {
                title: title,
                variant: variant,
                solid: true,
                toaster: "b-toaster-bottom-right",
                autoHideDelay: autoHideDelay,
                appendToast: append,
            });
        },
    }
}




// WEBPACK FOOTER //
// ./src/mixins/messagesMixin.js